import type { NavigateFunction } from "react-router-dom";

// Go back if we have history within the SPA, otherwise fall back to a route.
// window.history.length is unreliable but >2 is a decent heuristic for 'came from somewhere'.
export function goBackOrTo(nav: NavigateFunction, fallback: string) {
  if (window.history.length > 2) {
    nav(-1);
  } else {
    nav(fallback);
  }
}
